<template>
  <div>
      <div class="content-wrapper">
        <div class="container-fluid">
            <ol class="breadcrumb">
                <li class="breadcrumb-item active">Sobre</li>
            </ol> 
            <div class="box_general padding_bottom">
                <div class="header_box version_2">
                    <h2>
                        <i class="fa fa-info-circle"></i> Sobre o Projeto 
                    </h2>
                </div>
                <div class="row">
                    <div class="col-md-12 d-flex justify-center">
                        <div class="col-md-9 ">
                            <img src="../../public/assets/img/sobre.jpeg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>